<template>
  <div class="progress-container">
    <div
      v-for="step in steps"
      :key="step.type"
      class="progress-step"
      :class="{ '--completed': isStepCompleted(step.type), '--non-navigable': importSuccess }"
      @click="canNavigateToStep(step.type) ? handleStepNavigation(step.type) : null"
      role="button"
    >
      <span>{{ step.label }}</span>
      <CIcon v-if="isStepCompleted(step.type)" class="ml-2" name="checkMark" size="custom-size" :height="14" viewBox="0 0 32 32" />
    </div>
  </div>
</template>

<script>
import { IMPORT_CONTACTS_STEPS } from '../../constants'
import { mapGetters } from 'vuex'

export default {
  name: 'ImportContactsTabs',
  data() {
    return {
      IMPORT_CONTACTS_STEPS,
    }
  },
  computed: {
    ...mapGetters({
      isStepCompleted: 'audience/isStepCompleted',
    }),
    steps() {
      return [
        { type: IMPORT_CONTACTS_STEPS.IMPORT_CONTACTS, label: this.$t('audience-new.import-contacts-tabs.tab.import-contacts') },
        { type: IMPORT_CONTACTS_STEPS.MATCH_COLUMNS, label: this.$t('audience-new.import-contacts-tabs.tab.match-columns') },
        { type: IMPORT_CONTACTS_STEPS.CREATE_AUDIENCE, label: this.$t('audience-new.import-contacts-tabs.tab.create-audience') },
      ]
    },
    importSuccess() {
      return this.$store.state.audience.importContacts.importSuccess
    },
  },
  methods: {
    handleStepNavigation(step) {
      if (step === IMPORT_CONTACTS_STEPS.IMPORT_CONTACTS) {
        this.$emit('openConfirmationModal', IMPORT_CONTACTS_STEPS.IMPORT_CONTACTS)
        return
      }

      this.$store.dispatch('audience/setImportContactsStep', step)
    },

    canNavigateToStep(step) {
      if (this.importSuccess) return false

      return this.isStepCompleted(step)
    },
  },
}
</script>

<style lang="scss" scoped>
.progress-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 20px 0;
  gap: 5px;
}

.progress-step {
  flex-grow: 1;
  position: relative;
  padding: 13px 20px;
  background-color: var(--light-blue);
  color: var(--primary);
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
}

.--completed {
  background-color: var(--primary);
  color: var(--white);
  cursor: pointer;

  &.--non-navigable {
    cursor: not-allowed;
  }

  &.progress-step:not(:last-child)::after {
    border-left: 20px solid var(--primary);
  }
}

.progress-step:not(:last-child)::after {
  content: '';
  position: absolute;
  right: -20px;
  top: 0;
  bottom: 0;
  border-top: 23px solid transparent;
  border-bottom: 23px solid transparent;
  border-left: 20px solid var(--light-blue);
  z-index: 2;
}

.progress-step::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  border-top: 23px solid transparent;
  border-bottom: 23px solid transparent;
  border-left: 20px solid var(--gray-100);
  z-index: 1;
}

.progress-step {
  &.--completed:not(.--non-navigable) {
    &:hover {
      background-color: var(--purple-200);

      &::after {
        border-left-color: var(--purple-200);
      }
    }
  }
}
</style>
